import React from 'react';
import PropTypes from 'prop-types';

const Button = ({ className, disabled, label, onClick, type }) => (
  // eslint-disable-next-line react/button-has-type
  <button className={className} disabled={disabled} onClick={onClick} type={type}>
    {label}
  </button>
);

Button.defaultProps = {
  className: '',
  disabled: false,
  onClick: () => {},
  type: 'button',
};

Button.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
};

export default Button;
